import { Injectable } from '@angular/core'
import { APIService } from 'api/module'
import { SocketService } from 'common/util/module'
import { MediaFile } from 'elements-sdk'
import { firstValueFrom, race } from 'rxjs'
import { filter, first } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class MediaScannerService {
  assetBeingScanned: number|null = null

  constructor (
    private api: APIService,
    private socket: SocketService,
  ) {
    socket.subject('media:asset-is-being-scanned').subscribe(data => {
      this.assetBeingScanned = data.id
    })
  }

  async rescan (path: string, recursive?: boolean): Promise<void> {
    recursive ??= false

    const completed = firstValueFrom(race(
      this.socket.subject('media:single-scan-completed')
        .pipe(
          filter(m => m.path === path),
          first(),
        ),
      this.socket.subject('media:scanner-finished')
        .pipe(first()),
    ))

    await this.api.mediaLibrary.requestMediaScan({
      scannerScanEndpointRequest: {
        path,
        recursive,
      },
    })

    await completed
  }

  searchReindex (file: MediaFile): Promise<void> {
    return this.api.mediaLibrary.reindexMediaDirectory({
      id: file.id,
    })
  }
}
